import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import * as payoutsApi from '@/api/artist/payouts.js';

const state = {
  payoutBalance: null,
  loading: false,
};

const actions = {
  GET_PAYOUT_BALANCE({ commit }) {
    commit('setLoading', true);
    payoutsApi.getPayoutBalance()
      .then(({ data: { data: balanceObj } }) => {
        commit('setPayoutBalance', balanceObj);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setPayoutBalance(state, object) {
    state.payoutBalance = object;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations: { ...mutations, ...loadingMutation },
};
